import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

const ImportNetsuiteSandbox = () => {

  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const visible =
    ['GM'].includes(user.role) &&
    state.ncr.status.id === 4 &&
    !['gareth.dunning@asafe.com','stephen.renshaw@asafe.com','richard.humphries@asafe.com'].includes(user.id);

  return visible && (
    <Button className="import-netsuite" variant='success' href={`/api/ncr/${state.ncr.id}/netsuite_sandbox`}>
      Create Replacement Order in Sandbox
    </Button>
  );
}

export { ImportNetsuiteSandbox };